// extracted by mini-css-extract-plugin
module.exports = {"label":"CustomSelect_label__1rYle","errorText":"CustomSelect_errorText__3uPsE"};